import { observer } from 'mobx-react-lite'
import { ResponseValueContainer } from '@/features/jobs/questions/components/ResponseValueContainer'
import { type DetailsViewModel } from '@/features/jobs/details/DetailsViewModel'
import { type QuestionEditorViewModel } from '@/features/jobs/questions/QuestionEditorViewModel'
import { BoolQuestionAnswerEditorViewModel } from '@/features/jobs/questions/bool/BoolQuestionAnswerEditorViewModel'
import {
  IntakeAnswer,
  IntakeAnswerBoolValue,
  IntakeAnswers,
} from '@/features/jobs/details/components/IntakeAnswers'

export interface IntakeAnswersContainerProps {
  vm: DetailsViewModel
  /**
   * Offered beside every unanswered question.
   */
  onAskClient?: () => void
}

export const IntakeAnswersContainer = observer(function IntakeAnswersContainer({
  vm,
  onAskClient,
}: IntakeAnswersContainerProps) {
  return (
    <IntakeAnswers
      sections={vm.responseSections.map((section) => ({
        title: section.title,
        count: section.questions.length,
        answers: section.questions.map((q) => (
          <IntakeAnswerContainer
            key={q.id}
            questionVm={q}
            onAskClient={onAskClient}
          />
        )),
      }))}
    />
  )
})

interface IntakeAnswerContainerProps {
  questionVm: QuestionEditorViewModel
  onAskClient?: () => void
}

const IntakeAnswerContainer = observer(function IntakeAnswerContainer({
  questionVm,
  onAskClient,
}: IntakeAnswerContainerProps) {
  return (
    <IntakeAnswer
      id={questionVm.id}
      question={questionVm.title}
      isAnswered={questionVm.editor.isAnswered}
      value={
        questionVm.editor instanceof BoolQuestionAnswerEditorViewModel ? (
          <IntakeAnswerBoolValue
            answer={questionVm.editor.value ?? undefined}
          />
        ) : (
          <ResponseValueContainer editorVm={questionVm.editor} />
        )
      }
      onAskClient={onAskClient}
    />
  )
})
